import React, { useState, useRef, useEffect, useCallback } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemButton,
    List,
    Chip,
    ListItem,
    ListItemText,
    ListSubheader,
    TableContainer,
    TableCell,
    Table,
    TableHead,
    TableRow,
    TableBody,
    FormControlLabel,
    FormGroup,
    Checkbox,
    ButtonGroup,
    Tooltip,
    Fab
} from '@mui/material';

import QRCode from "qrcode.react";

import { green, grey, red, yellow } from "@mui/material/colors";

import dayjs from "dayjs";

import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext"

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import { CommonIcons, icons } from "../../common/CommonIcons"

// import LocationSelector from "../../selector/LocationSelector";

import SearchPackDocuments from "../../dialog/SearchPackDocuments"
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";

import { useDocuments, documentTypes, targetTypes as documentTargetTypes } from "../../../hooks/api/useDocuments";
import { useRepositories, repositoryTypes, targetTypes as repositoryTargetTypes } from "../../../hooks/api/useRepositories";
import {
    useScanData,
    outputTypes as scanDataOutputTypes,
    scopeTypes as scanDataScopeTypes,
    targetTypes as scanDataTargetTypes
} from "../../../hooks/useScanData";
// import { useItems, itemTypes } from "../../../hooks/api/useItems";

import { checkValueExists } from "../../../utils/dataSchema";
import { getUniqueValuesInArray } from "../../../utils/formatArray";
import { capitalizeString } from "../../../utils/formatString";

import {
    searchMethods,
    validationSchema,
    initialValues,
    initialRowValues,
} from "../../../schema/repositories/packageViewSchema"

import { CommonPdf, renderModes, documentTypes as commonPdfDocumentTypes } from "../../common/CommonPdf"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function ViewPackage({
    routeType
}) {

    // const { id } = useParams();

    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    // const { authData, getAvailableLocations } = useAuthAccess();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.repository.id, scopeTypes.repository.package.id)
    const { getScanData } = useScanData(scanDataOutputTypes.qrcode, scanDataScopeTypes.repository, scanDataTargetTypes.repository.package)

    const { setSystemLoading, openCustomDrawer } = useAppContextFeatures();
    const { list: listPackages, filterOperatorTypes } = useRepositories({ repositoryType: repositoryTypes.package, targetType: repositoryTargetTypes.package })
    const { get: getDocument, list: listDocuments } = useDocuments({ documentType: documentTypes.deliveryOrder })

    const [documentNos, setDocumentNos] = useState([])
    const [packageNos, setPackageNos] = useState([])

    const [searchDocumentConfig, setSearchDocumentConfig] = useState({
        show: false,
        documentType: [documentTypes.deliveryOrder],
        presetDocumentType: documentTypes.deliveryOrder,
        keyword: ""
    })

    const fetchPackages = async ({ packageNos }) => {

        setSystemLoading(true)

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "uom_lbl",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: "number_alternative",
                        operator: filterOperatorTypes.anyOf,
                        // value: values.search.packageNo
                        value: JSON.stringify(packageNos)
                    },
                    // {
                    //     name: "repo_number",
                    //     operator: filterOperatorTypes.contains,
                    //     value: values.search.packingNo
                    // }
                ]
            }

            const { data } = await listPackages(props)

            // console.log('data', data)

            if (data?.repositories) {
                if (data.repositories.length <= 0) {
                    promptMessage(false, `Invalid package no.`)
                } else {
                    let packages = data.repositories
                    setFieldValue(`packages`, values.packages.concat(packages))
                }
            }

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

        return false;

    }

    const fetchDocuments = async ({ documentNos }) => {

        setSystemLoading(true)

        try {

            if (documentNos.length <= 0) {
                throw new Error(`Invalid document no`)
            }

            // // need to check whether the document selected is in the list
            // const checkDuplicate = await checkDocumentIsSelected({ documentId: props?.id })

            // if(checkDuplicate){
            //     throw new Error(`Document : ${props?.data?.document?.doc_number} already selected`)
            // }

            // console.log('array', array)

            let array = [
                {
                    documentType: documentTypes.deliveryOrder
                },
                {
                    documentType: documentTypes.itemTransfer
                }
            ]

            let allItems = [];

            await Promise.all(

                // Use map to create an array of promises,  
                // with one promise for each item in myArray. 
                array.map(async item => {

                    let documentType = item?.documentType

                    let props = {
                        limit: -1,
                        skip: 0,
                        sortInfo: {
                            id: "id",
                            dir: -1,
                        },
                        filterValue: [
                            {
                                name: "doc_number",
                                operator: filterOperatorTypes.anyOf,
                                value: JSON.stringify(documentNos)
                            }
                        ]
                    }

                    props.documentType = documentType

                    const response = await listDocuments(props);

                    // console.log('response Doc : ', response?.data)

                    if (response?.data?.documents) {

                        response?.data?.documents.forEach(e1 => {

                            // assign back the states
                            // getting new append rows needed - support multiple
                            let newItems = getListItemsStates({ document: e1, items: e1?.items })

                            // console.log('newItems', newItems)

                            if (newItems.length) {
                                allItems = allItems.concat(newItems)
                            }
                        })


                    }

                })
            );

            // console.log('allItems', allItems)

            setFieldValue(`rows`, allItems)

            promptMessage(true, `${array.length} documents loaded successfully.`)

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)


    }

    const fetchPackagesByDocuments = async ({ documentNos }) => {

        setSystemLoading(true)

        try {

            // getting all selected documents
            // let documentNos = 

            if (documentNos.length <= 0) {
                setFieldValue(`packages`, [])
                throw new Error(`No document selected`)
                // console.error(`No document selected`)
                // return false;
            }

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "uom_lbl",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: "doc_number",
                        operator: filterOperatorTypes.havingInOr,
                        value: JSON.stringify(documentNos)
                    }
                ]
            }

            const { data } = await listPackages(props)


            if (data?.repositories) {
                if (data.repositories.length <= 0) {
                    promptMessage(false, `Invalid document No.`)
                } else {
                    let packages = data.repositories

                    // if(skipUpdateState === true)
                    // setFieldValue(`packages`, values.packages.concat(packages))
                    setFieldValue(`packages`, packages)

                }
            }

            return true;


        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

        return false;


    }

    const onSubmit = () => {

        try {

            // check the current search already in list
            const checkDup = values.packages.filter(i => i.number_alternative === values.search.packageNo)

            // console.log('c', checkDup, values.search.packageNo)

            if (checkDup.length) {
                throw new Error(`You've already selected this package`)
            }

            setPackageNos(prev => [values.search.packageNo])

        } catch (error) {
            promptMessage(false, `${error}`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
        enableReinitialize: true
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue } = formik;

    // for query search documents
    useEffect(() => {

        (async () => {
            try {
                // check query docNumbers
                let queryDocNumbers = searchParams.get("docNumbers") ? searchParams.get("docNumbers") : ""
                queryDocNumbers = queryDocNumbers && queryDocNumbers.indexOf(',') ? queryDocNumbers.split(',') : []

                console.log('queryDocNumbers', queryDocNumbers)

                if (queryDocNumbers.length) {

                    // if query make the search method is documents
                    setFieldValue(`search.method`, searchMethods.documents.id)

                    setDocumentNos(prev => queryDocNumbers)
                    fetchDocuments({ documentNos: queryDocNumbers })

                }

                // check query packageNumbers
                let queryPackageNumbers = searchParams.get("packageNumbers") ? searchParams.get("packageNumbers") : ""
                queryPackageNumbers = queryPackageNumbers && queryPackageNumbers.indexOf(',') ? queryPackageNumbers.split(',') : []

                console.log('queryPackageNumbers', queryPackageNumbers)

                if (queryPackageNumbers.length) {

                    // if query make the search method is package
                    setFieldValue(`search.method`, searchMethods.packages.id)

                    setPackageNos(prev => queryPackageNumbers)

                }


            } catch (err) {
                promptMessage(false, `${err}`)
            }
        })();

    }, [])

    useEffect(() => {

        fetchPackagesByDocuments({ documentNos })

    }, [documentNos])

    useEffect(() => {

        if (packageNos.length > 0) {
            fetchPackages({ packageNos })
        } else {
            setFieldValue(`packages`, [])
        }

    }, [packageNos])

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageView.id })) {

        //     props.push({
        //         displayText: "Print Preview",
        //         onClick: () => {

        //             openCustomDrawer({
        //                 show: true,
        //                 anchor: "right",
        //                 title: `Preview PDF`,
        //                 PaperProps: {
        //                     sx: { width: 2 / 3 }
        //                 },
        //                 // handleOnClose: () => setPreviewPdfOpen(false),
        //                 ComponentActions: <></>,
        //                 ComponentBody:
        //                     <CommonPdf
        //                         routeType={routeType}
        //                         renderMode={renderModes.preview.id}
        //                         documentType={commonPdfDocumentTypes.tripOrder.id}
        //                         document={{
        //                             title: data?.document?.doc_number
        //                         }}
        //                         data={data}
        //                     // customData={{
        //                     //     items: data
        //                     // }}
        //                     />
        //             })

        //             return true;

        //         }
        //     })

        // }

        return props

    }

    const RenderQRCodeHidden = () => {

        if (!values.packages) return <></>

        try {

            return (
                <>
                    {
                        values.packages.map((i, index) => {

                            // use the function to get the code data
                            let data = getScanData({
                                id: i?.number_alternative,
                                data: i
                            })

                            // console.log('qrCodeData', data)

                            return (
                                <div key={index} style={{ float: 'left', display: 'none' }}>
                                    <div>
                                        <QRCode
                                            id={i?.id}
                                            // value={i?.number_alternative}
                                            value={data}
                                            size={128}
                                            bgColor={`#ffffff`}
                                            fgColor={`#000000`}
                                            level={`H`}
                                            includeMargin={Boolean(true)}
                                        />
                                    </div>
                                </div>
                            )
                        })
                    }
                </>
            )

        } catch (error) {
            // promptMessage(false, `Error occured during scan code generation`)
            console.error(`Error : ${error}`)
        }

        return false

    }

    // calculate the total saved pack use qty for the doc id
    const getTotalPackedQtyByDocId = (id) => {

        let totalItemPacked = 0;

        values.packages.forEach(e => {

            // loop for all items
            const selected = e.items.filter(i => i.document_id === id)
            let totalUsed = 0;

            if (selected.length) {
                totalUsed = selected.reduce((total, i) => total + parseFloat(i.qty), 0)
            }

            totalItemPacked += totalUsed

        })

        return totalItemPacked;
    }

    // calculate the total saved pack use qty for the doc item id
    const getTotalPackedQtyByDocItemId = (id) => {

        let totalItemPacked = 0;

        values.packages.forEach(e => {
            // loop for all items
            const selected = e.items.filter(i => i.document_item_id === id)
            let totalUsed = 0;

            if (selected.length) {
                totalUsed = selected.reduce((total, i) => total + parseFloat(i.qty), 0)
            }

            totalItemPacked += totalUsed

        })

        return totalItemPacked;
    }

    // calculate the itemQty total allow for the doc id
    const getTotalItemQtyByDocId = (docId) => {
        // get current states
        const selected = values.rows.filter(i => i.documentId === docId)
        // const currentItemQty = selected.length? selected[0].qty.itemQty : 0

        const total = selected.reduce((total, i) => total + parseFloat(i.qty.itemQty), 0)

        return total
    }

    // calculate the maxQty allow for the doc item id
    const getMaxQtyByDocItemId = (docItemId) => {
        // get current states
        const selected = values.rows.filter(i => i.docItemId === docItemId)
        const currentItemQty = selected.length ? selected[0].qty.itemQty : 0

        return (currentItemQty - parseFloat(getTotalPackedQtyByDocItemId(docItemId)))
    }

    // check the doc item is fully packed
    const checkDocItemIsDone = (docItemId) => {
        return getMaxQtyByDocItemId(docItemId) <= 0
    }

    // calculate the total saved pack use qty in states
    const getTotalPackedQty = () => {

        let totalItemPacked = 0;

        values.packages.forEach(e => {
            // loop for all items
            let totalUsed = 0;
            totalUsed = e.items.reduce((total, i) => total + parseFloat(i.qty), 0)
            totalItemPacked += totalUsed

        })

        return totalItemPacked;
    }

    const checkDocumentIsSelected = async ({ documentId }) => {

        const selected = values.rows.filter(i => i.documentId === documentId)

        // console.log('aa', selected, documentId)

        return selected.length;

    }

    const getSelectedDocuments = () => {
        let ids = [];

        values.rows.forEach(e1 => {

            let isExist = false

            ids.forEach(e2 => {
                if (e2?.documentId === e1.documentId) isExist = true
            })

            if (isExist === false) {
                ids.push(e1)
            }

        })

        return ids

    }

    const handleRemoveSelectedDocument = ({ documentId, documentNumber }) => {

        const newRows = values.rows.filter(i => i.documentId !== documentId)

        setFieldValue('filterDocumentId', 'all')
        setFieldValue(`rows`, newRows)

        let queryDocNumbers = documentNos.filter(i => i !== documentNumber)

        setDocumentNos(prev => queryDocNumbers)

        fetchDocuments({ documentNos: queryDocNumbers })

    }

    const RenderDocumentSummaryRow = () => {
        return (

            <Grid container spacing={1} sx={{ mt: 1 }} >

                <Grid item xs={12} sm={12} md={6}>

                    <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<CommonIcons name={icons.add} />}
                        // onClick={() => handleAddItem({ rows: values.rows, setFieldValue }) }
                        onClick={() => {
                            setSearchDocumentConfig(prev => ({ ...prev, show: true }))
                        }}
                    >
                        Add Document
                    </Button>

                </Grid>

            </Grid>

        )
    }

    const RenderDocumentRows = () => {

        return (
            <Box
            >
                <List
                    disablePadding
                    sx={{
                        maxHeight: 500,
                        // minHeight: 700,
                        overflow: 'auto',
                        mx: -2
                    }}
                    subheader={<li />}
                >
                    {
                        // getDisplayItems().map((item, index) => {
                        values?.rows.map((item, index) => {

                            const itemValues = item;

                            const {
                                documentNumber,
                                documentDate,
                                documentId,
                                name,
                                code,
                                qty
                            } = itemValues

                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            // get the items summary
                            // const itemsCount = data?.items.reduce((total, i) => total + parseFloat(i.qty), 10)

                            // need to check for hide or show
                            let hide = false
                            // check if the filter apply
                            if (values.filterDocumentId && values.filterDocumentId !== 'all') {
                                // items = values.rows.filter(i => i.documentId === values.filterDocumentId)
                                if (values.filterDocumentId !== documentId) {
                                    hide = true
                                }
                            }

                            const a = values.rows;// getDisplayItems();
                            let header = {};

                            // check need to show header or not
                            if (index === 0) {
                                header = {
                                    title: `${documentNumber}`,
                                    subTitle: `${documentDate}`
                                }
                            } else {

                                let prevDocumentNumber = a[index - 1]?.documentNumber

                                if (prevDocumentNumber !== documentNumber) {
                                    header = {
                                        title: `${documentNumber}`,
                                        subTitle: `${documentDate}`
                                    }
                                } else {
                                    header = {}
                                }

                            }

                            let itemQtyDone = getTotalPackedQtyByDocItemId(itemValues?.docItemId);

                            return (
                                <li key={`section-${index}`} style={{ display: hide ? 'none' : 'block' }}>
                                    <ul>
                                        {
                                            header?.title &&

                                            <ListSubheader
                                                sx={{
                                                    px: 2,
                                                    m: 0,
                                                    backgroundColor: grey[200],
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            color: grey[900],
                                                            fontWeight: '700'
                                                        }}
                                                    >
                                                        {`${header.title} (${header.subTitle})`}
                                                    </Typography>
                                                    {/* <Chip 
                                                        label={`${header.title}`}
                                                        size="medium"
                                                        variant="outlined"
                                                        color={"primary"}
                                                        // sx={{
                                                        //     width: '100%'
                                                        // }}
                                                    />
                                                    <Chip 
                                                        label={`${header.subTitle}`}
                                                        size="medium"
                                                        variant="outlined"
                                                        color={"primary"}
                                                        sx={{
                                                            ml: 1
                                                        }}
                                                    /> */}
                                                </Box>
                                                <Box
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    justifyContent={"space-between"}
                                                    alignItems={"center"}
                                                >
                                                    <Chip
                                                        // icon={
                                                        //     <CommonIcons
                                                        //         name={icons.tick}
                                                        //     />
                                                        // }
                                                        label={
                                                            `${getTotalPackedQtyByDocId(itemValues.documentId)} / ${getTotalItemQtyByDocId(itemValues.documentId)}`
                                                        }
                                                        variant={
                                                            getTotalPackedQtyByDocId(itemValues.documentId) === getTotalItemQtyByDocId(itemValues.documentId) ?
                                                                `contained` : `outlined`
                                                        }
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: getTotalPackedQtyByDocId(itemValues.documentId) === getTotalItemQtyByDocId(itemValues.documentId) ?
                                                                green[400] : `default`
                                                        }}
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        // color="danger"
                                                        sx={{
                                                            color: red[500]
                                                        }}
                                                        onClick={() => {
                                                            // console.log('delete', i.documentId)
                                                            handleRemoveSelectedDocument({ documentId, documentNumber })
                                                        }}
                                                    >
                                                        <CommonIcons name={icons.cancel} />
                                                    </IconButton>
                                                </Box>
                                            </ListSubheader>
                                        }
                                        <ListItem
                                            key={index}
                                            divider
                                            disablePadding
                                            sx={{
                                                px: 2,
                                                py: 0.5
                                            }}
                                            selected={
                                                Boolean(itemValues?.qty?.value && parseFloat(itemValues.qty.value) > 0)
                                            }
                                        >
                                            <Grid item xs={12} sm={12} md={12}>

                                                <Grid container spacing={1} >

                                                    <Grid item xs={12} sm={12} md={0.5} display={"flex"} justifyContent={"center"} alignItems={"center"}>

                                                        {
                                                            checkDocItemIsDone(itemValues.docItemId) ?
                                                                (
                                                                    <CommonIcons
                                                                        name={icons.tick}
                                                                        sx={{
                                                                            color: green[500],
                                                                            width: 50,
                                                                            height: 50
                                                                        }}
                                                                    />
                                                                )
                                                                :
                                                                (
                                                                    <CommonIcons name={icons.chevronRight} />
                                                                )
                                                        }


                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={7}>
                                                        <ListItemText
                                                            primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{name}</Typography>}
                                                            secondary={<Typography sx={{ fontSize: 12 }}>{`Code : ${code}`}</Typography>}
                                                        />

                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={2} textAlign={"center"}>
                                                        <ListItemText
                                                            primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{itemValues?.qty?.itemQty ? itemValues.qty.itemQty : ""}</Typography>}
                                                            secondary={<Typography sx={{ fontSize: 12 }}>{`${itemValues?.uomName}`}</Typography>}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={2.5} textAlign={"right"}>

                                                        {
                                                            itemQtyDone === itemValues?.qty?.itemQty ?
                                                                (
                                                                    <Chip
                                                                        variant="contained"
                                                                        color={"primary"}
                                                                        label={`Completed (${itemQtyDone} / ${itemValues?.qty?.itemQty})`}
                                                                        size="small"
                                                                    />
                                                                )
                                                                :
                                                                (
                                                                    <Chip
                                                                        variant="outlined"
                                                                        color={"primary"}
                                                                        label={`${itemQtyDone} / ${itemValues?.qty?.itemQty}`}
                                                                        size="small"
                                                                    />
                                                                )
                                                        }

                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                    </ul>
                                </li>
                            )
                        })
                    }
                </List>

                {/* <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid> */}

                {
                    (getSelectedDocuments().length <= 0) &&
                    <RenderDefaultSelection />
                }

                {
                    RenderDocumentSummaryRow()
                }

            </Box>
        )
    }

    const RenderRelatedPackageEach = ({ row, items, index }) => {

        // get the total qty
        let totalQty = items.reduce((total, item) => total + parseFloat(item.qty), 0)

        return (
            <StyledCard sx={{ mt: 2, p: 0 }}>
                <TableContainer
                // component={Paper}
                >
                    <Table
                        // sx={{ minWidth: 650 }} 
                        aria-label="simple table"
                        size="small"
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" sx={{ backgroundColor: grey[800], color: grey[100] }}>#{index + 1}</TableCell>
                                <TableCell align="left" sx={{ backgroundColor: grey[800], color: grey[100], fontSize: 12 }} colSpan={2}>
                                    <Box>
                                        {row.number_alternative} ({row.repo_date})
                                    </Box>
                                    <Box
                                        display={"flex"}
                                        flexDirection={"row"}
                                        justifyContent={"flex-start"}
                                        alignItems={"center"}
                                    >
                                        <CommonIcons name={icons.info} sx={{ mr: 1 }} />
                                        {row?.remark}
                                    </Box>
                                </TableCell>
                                <TableCell align="right" sx={{ backgroundColor: grey[800] }} width={160}>

                                    <Box>
                                        <Chip
                                            variant="outlined"
                                            size="small"
                                            // color={}
                                            sx={{
                                                color: grey[100]
                                            }}
                                            label={
                                                `${capitalizeString({ val: row.packing_type })}`
                                            }
                                        />
                                    </Box>
                                    <Box
                                        sx={{ color: grey[100] }}
                                    >
                                        1 {row.uom_lbl} (Qty: {totalQty})
                                    </Box>
                                </TableCell>
                                {/* <TableCell align="left">Item</TableCell>
                                <TableCell align="right">Qty</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">No.</TableCell>
                                <TableCell align="left" width={160}>Document</TableCell>
                                <TableCell align="left">Items</TableCell>
                                <TableCell align="right" width={160}>Qty</TableCell>
                                {/* <TableCell align="left">Item</TableCell>
                                <TableCell align="right">Qty</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                items.map((item, index) => {

                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" align="center" scope="row" sx={{ width: 40 }}>
                                                {(index + 1)}
                                            </TableCell>
                                            <TableCell align="left">
                                                <ListItemText
                                                    primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{item.doc_number}</Typography>}
                                                    secondary={<Typography sx={{ fontSize: 12 }}>{item.doc_type}</Typography>}
                                                />
                                            </TableCell>
                                            <TableCell align="left">
                                                <ListItemText
                                                    primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{item.item_name}</Typography>}
                                                    secondary={<Typography sx={{ fontSize: 12 }}>{item.code}</Typography>}
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <ListItemText
                                                    primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{parseFloat(item.qty)} {item?.uom_name}</Typography>}
                                                // secondary={<Typography sx={{ fontSize: 12 }}>{item?.packing_type}</Typography>}
                                                />
                                            </TableCell>
                                            {/* <TableCell align="right">1</TableCell> */}
                                        </TableRow>
                                    )
                                })
                            }
                            {/* <TableRow>
                                <TableCell align="right" colSpan={3}>Total Qty</TableCell>
                                <TableCell align="right">{totalQty}</TableCell>
                            </TableRow>  */}
                        </TableBody>
                    </Table>
                </TableContainer>
            </StyledCard>
        )
    }

    const RenderRelatedPackages = () => {

        const getRows = () => {

            return values.packages

        }

        return (
            <Grid container spacing={1}>

                {
                    getRows().map((i, index) => {
                        return (
                            <Grid item key={index} xs={6} sm={6} md={6} textAlign={"left"}>
                                <RenderRelatedPackageEach

                                    index={index}
                                    items={i.items}
                                    row={i}
                                />
                            </Grid>
                        )
                    })
                }
            </Grid>
        )
    }

    const RenderFormPackages = () => {

        const totalPackages = values.packages.length

        return (
            <>
                <Grid container spacing={1}>
                    <Grid item xs={6} sm={6} md={6} textAlign={"left"}>

                        <Box sx={{ pl: 1 }}>
                            <Typography
                                sx={{
                                    fontWeight: '700',
                                    pt: 0,
                                    // pl: 1,
                                    textAlign: 'left',
                                    fontSize: 20
                                }}
                            >
                                Related Packages
                            </Typography>
                            <Typography
                                sx={{
                                    // fontWeight: '700',
                                    pt: -2,
                                    // pl: 1,
                                    textAlign: 'left',
                                    fontSize: 13
                                }}
                            >
                                Packed packages details
                            </Typography>
                        </Box>

                    </Grid>

                    <Grid item xs={6} sm={6} md={6} textAlign={"right"} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>

                        {
                            values.packages.length > 0 &&
                            <Box
                                sx={{ pr: 1 }}
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                            >
                                <Box
                                    display={"flex"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    sx={{
                                        backgroundColor: grey[800],
                                        px: 1,
                                        borderRadius: 1,
                                        // borderColor: grey[500],
                                        // borderWidth: 1,
                                        // borderStyle: 'solid'
                                    }}
                                >
                                    <CommonIcons
                                        name={icons.products}
                                        sx={{
                                            color: grey[100]
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            fontSize: 25,
                                            ml: 1,
                                            color: grey[100]
                                        }}
                                    >
                                        {values.packages.length}
                                    </Typography>
                                </Box>

                                <Box
                                    display={"flex"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    sx={{
                                        backgroundColor: grey[800],
                                        px: 1,
                                        borderRadius: 1,
                                        ml: 1,
                                        // borderColor: grey[500],
                                        // borderWidth: 1,
                                        // borderStyle: 'solid'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: 25,
                                            // ml: 1,
                                            color: grey[100]
                                        }}
                                    >
                                        {`Total Qty: ${getTotalPackedQty()}`}
                                    </Typography>
                                </Box>

                                <Button
                                    variant="contained"
                                    color={"primary"}
                                    sx={{
                                        ml: 1
                                    }}
                                    onClick={() => {

                                        let data = values.packages

                                        // getting the items for related documents
                                        data.forEach((i, index) => {
                                            let dataUrl = document.getElementById(i.id).toDataURL()
                                            data[index].qrCodeData = dataUrl
                                        })

                                        // getting the values packages qrcode
                                        data.forEach((i, index) => {
                                            let dataUrl = document.getElementById(i.id).toDataURL()
                                            data[index].qrCodeData = dataUrl

                                            // get related documents
                                            let documentNos = getUniqueValuesInArray({ array: i.items, uniqueKey: "doc_number" }) // make sure no duplicate values

                                            data[index].documentNos = documentNos

                                            // getting total qty
                                            let totalQty = i.items.reduce((total, item) => total + parseFloat(item.qty), 0)

                                            data[index].totalQty = totalQty

                                        })

                                        openCustomDrawer({
                                            show: true,
                                            anchor: "right",
                                            title: `Preview PDF`,
                                            PaperProps: {
                                                sx: { width: 2 / 3 }
                                            },
                                            // handleOnClose: () => setPreviewPdfOpen(false),
                                            ComponentActions: <></>,
                                            ComponentBody:
                                                <CommonPdf
                                                    renderMode={renderModes.preview.id}
                                                    documentType={commonPdfDocumentTypes.packageLabel.id}
                                                    document={{
                                                        title: "Package Labels"
                                                    }}
                                                    data={data}
                                                // customData={{
                                                //     items: data
                                                // }}
                                                />
                                        })

                                    }}
                                >
                                    <CommonIcons name={icons.print} sx={{ mr: 1 }} />
                                    Print {`(${values.packages.length})`} Labels
                                </Button>

                            </Box>
                        }

                    </Grid>
                </Grid>

                {
                    totalPackages <= 0 ?
                        (
                            <StyledCard sx={{ mt: 1, p: 0 }}>
                                <RenderDefaultSelection />
                            </StyledCard>
                        )
                        :
                        (
                            RenderRelatedPackages()
                        )
                }

            </>
        )
    }

    const RenderDefaultSelection = ({ children }) => {
        return (
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                    backgroundColor: grey[100],
                    minHeight: 200,
                    borderRadius: 1,
                }}
            >
                {
                    children && children
                }
                {
                    !children &&
                    (
                        <Typography
                            sx={{
                                color: grey[400],
                                textAlign: 'center',
                            }}
                        >
                            {`No Selection`}
                        </Typography>
                    )
                }
            </Box>
        )
    }

    const RenderFormSearchPackage = () => {
        return (

            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                    <CommonSectionHeader
                        title={`Packages`}
                        subTitle={`Search the packages at the same time`}
                    />

                </Grid>
                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                    <TextField
                        margin="dense"
                        size="small"
                        fullWidth
                        name={"search.packageNo"}
                        label="Package No."
                        type="text"
                        variant="outlined"
                        value={
                            values?.search?.packageNo ? values.search.packageNo : ''
                        }
                        onChange={handleChange}
                        InputProps={{
                            sx: {
                                py: 1
                            },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Button
                                        variant="contained"
                                        color={"primary"}
                                        fullWidth
                                        type="submit"
                                    >
                                        <CommonIcons name={icons.search} sx={{ mr: 1 }} /> Search
                                    </Button>
                                </InputAdornment>
                            ),
                        }}
                        error={Boolean(errors?.search?.packageNo)}
                        helperText={errors?.search?.packageNo}
                    />

                </Grid>


                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                    {
                        values.packages.map((i, index) => {
                            return (
                                <Chip
                                    key={index}
                                    label={`${i?.number_alternative} (${i.repo_date})`}
                                    onDelete={() => {
                                        setFieldValue(`packages`, values.packages.filter(i2 => i2.id !== i.id))
                                    }}
                                    sx={{
                                        width: '100%',
                                        pr: 1,
                                        mr: 1,
                                        mb: 1
                                    }}
                                />
                            )
                        })
                    }

                </Grid>

            </Grid>
        )
    }

    const RenderFormSearchDocument = () => {
        return (

            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                    <CommonSectionHeader
                        title={`Documents`}
                        subTitle={`Search the documents at the same time`}
                    />

                </Grid>
                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                    {
                        getSelectedDocuments().length > 0 &&

                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                        // error={Boolean(itemErrors?.inventoryBatchId)}
                        >
                            <InputLabel id="documents">Filter</InputLabel>
                            <Select
                                // disabled={
                                //     !(itemValues?.itemId)
                                // }
                                // labelId="inventoryBatchId"
                                label="Filter"
                                // name={`rows.${index}.inventoryBatchId`}
                                // onChange={handleChange}
                                onChange={(event) => {
                                    setFieldValue(`filterDocumentId`, event.target.value)
                                }}
                                value={
                                    (
                                        values?.filterDocumentId === "all" ?
                                            "all"
                                            :
                                            checkValueExists({
                                                searchFieldId: "documentId",
                                                dataSearch: getSelectedDocuments(),
                                                valueToCompare: values?.filterDocumentId
                                            })
                                    )
                                    // values?.filterDocumentId
                                }
                                renderValue={(id) => {
                                    const selected = getSelectedDocuments().filter(i => i.documentId === id)

                                    if (selected && selected.length > 0) {
                                        return (
                                            <>
                                                {selected[0].documentNumber}
                                            </>
                                        )
                                    }

                                    return <>Show All</>

                                }}
                            >
                                <MenuItem
                                    key={0}
                                    value={'all'}
                                    sx={{
                                        textTransform: 'capitalize',
                                    }}
                                >
                                    Show All
                                </MenuItem>

                                {
                                    getSelectedDocuments().map((i, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={i.documentId}
                                                sx={{
                                                    // textTransform: 'capitalize',
                                                    // display: 'flex',
                                                    // flexDirection: 'row',
                                                    // justifyContent: 'space-between',
                                                    // alignItems: 'center'
                                                }}
                                            >
                                                {i.documentNumber}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            {/* <FormHelperText>
                                    {
                                        itemErrors?.inventoryBatchId?
                                            itemErrors?.inventoryBatchId
                                            :
                                            getSelectedInventoryBatch({ selectedIndexNo: index })?.batchId?
                                                getSelectedInventoryBatch({ selectedIndexNo: index }).label
                                                :
                                                ""
                                    }
                                </FormHelperText> */}
                        </FormControl>

                    }

                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    {
                        RenderDocumentRows()
                    }
                </Grid>
            </Grid>
        )
    }

    const RenderForm = () => {

        // if(!values) return <></>

        return (
            <form onSubmit={handleSubmit}>

                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <StyledCard sx={{ p: 0 }}>

                            <Box>
                                <ButtonGroup
                                    fullWidth
                                    variant="outlined"
                                    aria-label="outlined primary button group"
                                    sx={{
                                        // mt: 1
                                    }}
                                >
                                    <Button
                                        variant={values.search.method === searchMethods.packages.id ? 'contained' : 'outlined'}
                                        onClick={() => {

                                            if (values.search.method === searchMethods.packages.id) return false

                                            setFieldValue(`search.method`, searchMethods.packages.id)
                                            setFieldValue(`packages`, [])
                                            setFieldValue(`rows`, [])

                                            return true;

                                        }}
                                    >
                                        Search By Packages
                                    </Button>
                                    <Button
                                        variant={values.search.method === searchMethods.documents.id ? 'contained' : 'outlined'}
                                        onClick={() => {

                                            if (values.search.method === searchMethods.documents.id) return false

                                            setFieldValue(`search.method`, searchMethods.documents.id)
                                            setFieldValue(`packages`, [])
                                            setFieldValue(`search.packageNo`, "")

                                            return true;
                                        }}
                                    >
                                        Search By Documents
                                    </Button>
                                </ButtonGroup>
                            </Box>

                            <Box
                                sx={{
                                    p: 2
                                }}
                            >
                                {
                                    values.search.method === searchMethods.packages.id ? RenderFormSearchPackage() : RenderFormSearchDocument()
                                }
                            </Box>
                        </StyledCard>
                    </Grid>


                    <Grid item xs={12} sm={12} md={12} textAlign={"left"} sx={{ mt: 1 }}>



                        {
                            RenderFormPackages()
                        }

                        {/* {
                                RenderFormPackingMethod()
                            } */}

                        {/* {
                                RenderFormActions()
                            } */}

                    </Grid>

                </Grid>

            </form>
        )
    }

    const getListItemsStates = ({ document, items }) => {

        let newItems = [];

        items.forEach((e1) => {
            const newItem = {
                ...initialRowValues,
                documentId: document?.id,
                documentDate: document?.doc_date,
                documentNumber: document?.doc_number,
                docItemId: e1.id,
                itemId: e1.item_id,
                name: e1.item_name,
                code: e1.code,
                description: e1?.description,
                price: e1?.uom_price,
                uomId: e1?.uom_id,
                uomName: e1?.uom_name,
                qty: {
                    value: "0",
                    // maxQty: parseFloat(e1.qty),
                    maxQty: getMaxQtyByDocItemId(e1.id),
                    itemQty: parseFloat(e1.qty)
                },
                data: JSON.stringify(e1)
            }
            newItems.push(newItem)
        })

        return newItems

    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.viewPackage })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle="View Package"
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Packages",
                        props: {
                            href: getRoute('repositories/packages')
                        }
                    },
                    {
                        displayText: "View Package",
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    RenderForm()
                    :
                    (
                        <CommonRestricted />
                    )
            }

            {
                searchDocumentConfig?.show &&

                <SearchPackDocuments
                    id={`0`}
                    config={
                        {
                            allowDocumentTypes: searchDocumentConfig?.documentType,
                            presetDocumentType: searchDocumentConfig?.presetDocumentType,
                            filterKeyword: searchDocumentConfig?.keyword
                        }
                    }
                    show={searchDocumentConfig.show}
                    handleOnCancel={() => {
                        setSearchDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSearchChange={(event) => {
                        // setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                    }}
                    handleOnSelect={async (props) => {

                        try {
                            setSearchDocumentConfig(prev => ({ ...prev, show: false }))

                            // need to check whether the document selected is in the list
                            const checkDuplicate = await checkDocumentIsSelected({ documentId: props?.id })

                            if (checkDuplicate) {
                                throw new Error(`Document : ${props?.data?.document?.doc_number} already selected`)
                            }

                            let queryDocNumbers = documentNos.concat(props?.data?.document?.doc_number)

                            setDocumentNos(prev => queryDocNumbers)

                            fetchDocuments({ documentNos: queryDocNumbers })

                        } catch (error) {
                            promptMessage(false, `Selection Failed : ${error}`)
                        }

                        return true;

                    }}
                    textProps={{
                        disabled: true,
                        // value: itemValues?.name? itemValues.name : "",
                        // error: Boolean(itemErrors?.name),
                        // helperText: itemErrors?.name
                    }}
                />
            }

            {
                RenderQRCodeHidden()
            }

        </Box>
    )
}